import './style/index.less';
import VerifyChangePane from './VerifyChangePane';

export default VerifyChangePane;
